














import Vue from "vue";
import { Prop, Watch, Component } from "vue-property-decorator";

@Component( {
    name: "Componente",
    props: {},
    components: {}
} )
export default class Componente extends Vue
{

    @Prop( { type: Array, default: [] } )
    public Items: Array<any>;

    @Prop( { type: Number } )
    public value: number;

    @Prop( { type: String } )
    public Titulo: string;

    constructor()
    {
        super();
    }

    public selectedIndex: number = -1;
    public get SelectedIndex(): number
    {
        return this.selectedIndex;
    }
    public set SelectedIndex( x: number )
    {
        this.selectedIndex = x;
        this.$emit( 'input', this.SelectedIndex );
    }

    @Watch( 'value', { immediate: true } )
    onIndex()
    {
        if ( this.SelectedIndex !== this.value )
            this.SelectedIndex = this.value;
    }

    public get SelectedItem(): any
    {
        if ( this.SelectedIndex >= 0 )
            return this.Items[this.SelectedIndex];
        return -1;
    }

}
